// Client component to set hreflang tags into context for usage by LanguageCountrySelector

'use client';

import { useEffect } from 'react';
import { useHreflang } from '@/ui/providers/hrefLangContext';
import { Hreflang } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';

function SetHreflang({ hreflangs }: { hreflangs?: Hreflang[] | null }) {
  const { setHreflangs } = useHreflang();

  useEffect(() => {
    if (!hreflangs) {
      return;
    }
    setHreflangs(hreflangs);
  }, [hreflangs, setHreflangs]);

  return null;
}

export default SetHreflang;
